<script setup lang="ts">
import type HotelPackage from '@itinerary/hotel/HotelPackage';

const { item } = defineProps<{
    item: HotelPackage;
}>();
const checkinDate = computed(() =>
    dayConfig.js(item.fromDate).format('dddd DD MMMM')
);
const checkoutDate = computed(() =>
    dayConfig.js(item.toDate).format('dddd DD MMMM')
);
</script>

<template>
    <div class="trip-view-container">
        <div class="times-section">
            <mr-typography weight="500" class="time">
                {{ item.checkinHour }}
            </mr-typography>
            <mr-typography weight="500" class="time">
                {{ item.checkoutHour }}
            </mr-typography>
        </div>
        <div class="time-line-section">
            <span class="circle-icon" />
            <mr-divider vertical class="divider" />
            <span class="circle-icon" />
        </div>
        <div class="info-section">
            <mr-typography weight="500" white-space="nowrap" class="title">
                ورود: {{ checkinDate }}
            </mr-typography>
            <div class="trip-info">
                <mr-typography color="var(--cool-gray-600)" class="info-title">
                    {{ item.nights }} شب اقامت
                </mr-typography>
            </div>
            <mr-typography weight="500" white-space="nowrap" class="title">
                خروج: {{ checkoutDate }}
            </mr-typography>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.trip-view-container {
    display: flex;
    align-items: stretch;
}

.times-section {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
    width: 40px;
    .time {
        display: flex;
    }
}

.time-line-section {
    flex: 0 0 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 20px;
    padding: 8px 0;
    .circle-icon {
        width: 10px;
        height: 10px;
        border-radius: 100%;
        background-color: usePalette($p-cool-gray, 400);
    }
    .divider {
        flex: 1;
        margin: 8px 0;
    }
}

.info-section {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title {
        &:not(:last-child) {
            margin-bottom: -4px;
        }
    }
    .trip-info {
        flex: 1;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin: 8px 0;
    }
    .info-title {
        margin-right: 4px;
    }
}
</style>
